import { Controller } from '@hotwired/stimulus';

export default class FileInputController extends Controller {
  static values = {
    filename: String,
    filePath: String
  };

  static targets = [
    'input',
    'filename',
    'removeButton',
    'removeFlag',
    'nameField',
    'descriptionField'
  ];

  connect() {
    this.change();
  }

  change() {
    const file = this.inputTarget.files[0];

    if (file) {
      this.filenameTarget.innerHTML  = this.linkTag(file.name, URL.createObjectURL(file));
      this.removeButtonTarget.hidden = false;

      if (this.hasRemoveFlagTarget) { this.removeFlagTarget.value = ''; }
    } else if (this.filenameValue) {
      if (this.filePathValue) {
        this.filenameTarget.innerHTML = this.linkTag(this.filenameValue, this.filePathValue);
      } else {
        this.filenameTarget.textContent = this.filenameValue;
      }

      this.removeButtonTarget.hidden = false;

      if (this.hasRemoveFlagTarget) { this.removeFlagTarget.value = ''; }
    } else {
      this.filenameTarget.textContent = 'ファイルが選択されていません';
      this.removeButtonTarget.hidden  = true;

      if (this.hasRemoveFlagTarget) { this.removeFlagTarget.value = 'true'; }
    }
  }

  remove() {
    this.inputTarget.value = '';
    this.filenameValue = undefined;

    if (this.hasNameFieldTarget) {
      this.nameFieldTarget.value = '';
    }

    if (this.hasDescriptionFieldTarget) {
      this.descriptionFieldTarget.value = '';
    }

    this.change();
  }

  linkTag(label, url) {
    const linkTag = document.createElement('a');

    linkTag.href        = url;
    linkTag.textContent = label;
    linkTag.target      = '_blank';

    const wrapTag = document.createElement('div');

    wrapTag.classList.add('underline');
    wrapTag.appendChild(linkTag);

    return wrapTag.outerHTML;
  }
}
